import API from "helpers/api";
import { Apis } from "services/api";
import { getAPIResponse } from "helpers/getApiResponse";

export const getFeedbackDetails = async (id) => {
	try {
		let response = await API.get(`${Apis.Feedback}/${id}`);
		return getAPIResponse(response);
	} catch (err) {
		return getAPIResponse(err?.response);
	}
};

export const getFeedbackNotes = async (id) => {
	try {
		let response = await API.get(`${Apis.FeedbackNotes}?feedbackId=${id}`);
		return getAPIResponse(response);
	} catch (err) {
		return getAPIResponse(err?.response);
	}
};

export const getFeedbackImages = async (id) => {
	try {
		let response = await API.get(`${Apis.FeedbackImages}?feedbackId=${id}`);
		return getAPIResponse(response);
	} catch (err) {
		return getAPIResponse(err?.response);
	}
};

export const getPositionUsers = async (id) => {
	try {
		let response = await API.get(`${Apis.positions}/${id}/users`);
		return getAPIResponse(response);
	} catch (err) {
		return getAPIResponse(err?.response);
	}
};

export const getFeedbackAvailableUsers = async ({ siteDepartmentID, positionID } = {}) => {
	try {
		const params = [];
		if (siteDepartmentID) params.push(`siteDepartmentID=${siteDepartmentID}`);
		if (positionID) params.push(`positionID=${positionID}`);
		const query = params.length ? `?${params.join("&")}` : "";
		let response = await API.get(`${Apis.Feedback}/AvailableUsers${query}`);
		return getAPIResponse(response);
	} catch (err) {
		return getAPIResponse(err?.response);
	}
};

export const addFeedbackNotes = async (payload) => {
	try {
		let response = await API.post(`${Apis.FeedbackNotes}`, payload);
		return getAPIResponse(response);
	} catch (err) {
		return getAPIResponse(err?.response);
	}
};

export const updateFeedbackNote = async (noteId, note) => {
	try {
		const patchDocument = [
			{
				op: "replace",
				path: "/note",
				value: note
			}
		];
		let response = await API.patch(`${Apis.FeedbackNotes}/${noteId}`, patchDocument);
		return getAPIResponse(response);
	} catch (err) {
		return getAPIResponse(err?.response);
	}
};

export const uploadFeedbackImage = async (id, payload, config) => {
	try {
		let response = await API.post(
			`${Apis.Feedback}/${id}/uploadImage`,
			payload,
			config
		);
		return getAPIResponse(response);
	} catch (err) {
		return getAPIResponse(err?.response);
	}
};

export const updateFeedback = async (id, payload) => {
	try {
		let response = await API.patch(`${Apis.Feedback}/${id}`, payload);
		return getAPIResponse(response);
	} catch (err) {
		return getAPIResponse(err?.response);
	}
};

export const getFeedbackTasks = async (modelVersionStageId, modelVersionZoneId, modelVersionIntervalId, modelVersionRoleId) => {
	try {
		let url = `${Apis.Feedback}/Tasks`;
		const params = [];
		if (modelVersionStageId) params.push(`ModelVersionStageId=${modelVersionStageId}`);
		if (modelVersionZoneId) params.push(`ModelVersionZoneId=${modelVersionZoneId}`);
		if (modelVersionIntervalId) params.push(`ModelVersionIntervalId=${modelVersionIntervalId}`);
		if (modelVersionRoleId) params.push(`ModelVersionRoleId=${modelVersionRoleId}`);
		if (params.length) url += `?${params.join("&")}`;
		let response = await API.get(url);
		return getAPIResponse(response);
	} catch (err) {
		return getAPIResponse(err?.response);
	}
};

export const deleteDefectAudio = async (id) => {
	try {
		let response = await API.delete(`${Apis.Defects}/${id}/audio`);
		return getAPIResponse(response);
	} catch (err) {
		return getAPIResponse(err?.response);
	}
};

export const getFeedbackDocuments = async (feedbackId) => {
	try {
		let response = await API.get(
			`${Apis.FeedbackDocuments}?feedbackId=${feedbackId}`
		);
		return getAPIResponse(response);
	} catch (err) {
		return getAPIResponse(err?.response);
	}
};

export const uploadFeedbackDocument = async (payload) => {
	try {
		let response = await API.post(`${Apis.FeedbackDocuments}`, payload);
		return getAPIResponse(response);
	} catch (err) {
		return getAPIResponse(err?.response);
	}
};

export const deleteFeedbackDocument = async (id) => {
	try {
		let response = await API.delete(`${Apis.FeedbackDocuments}/${id}`);
		return getAPIResponse(response);
	} catch (err) {
		return getAPIResponse(err?.response);
	}
};
